import { watch } from 'vue'

import { useCartActions } from '~/composables/useCartActions'

/** Refetches the cart's estimates whenever the order type changes. */
export function useCartOrderTypeRefresh(orderType: () => string) {
  const { fetchCart } = useCartActions()

  watch(orderType, () => {
    void fetchCart()
  })
}
